"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _loyalty = require("../clients/loyalty.cleint");
var _constants2 = require("../constants");
var _class, _descriptor, _descriptor2;
/**
 * WalletHistoryStore
 */
let WalletHistoryStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function WalletHistoryStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, WalletHistoryStore);
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "API_STATE", _descriptor2, this);
    /**
     * change Password
     * @param {string} newPassword
     * @param {string} oldPassword
     * @param {Function} errorHandler
     */
    this.fetch = (0, _mobx.flow)(function* ({
      errorHandler = () => {}
    }) {
      this.API_STATE = _constants.API_STATE.LOADING;
      try {
        const response = yield _loyalty.LoyaltyClient.checkHistory({});
        this.onSuccess(response);
      } catch (error) {
        this.onError(error, errorHandler);
      }
    });
    this.$env = $env;
    this.updateInitialState(initialState);
  }
  (0, _createClass2.default)(WalletHistoryStore, [{
    key: "isLoading",
    get:
    /**
     * is loading
     * @return {boolean}
     */
    function () {
      return this.API_STATE === _constants.API_STATE.LOADING;
    }

    /**
     * is fetched
     * @return {boolean}
     */
  }, {
    key: "isFetched",
    get: function () {
      return this.API_STATE === _constants.API_STATE.SUCCESS;
    }

    /**
     * is user not enrolled
     * @returns {boolean}
     */
  }, {
    key: "isUserNotEnrolled",
    get: function () {
      return this.data.code === _constants2.WALLET_CODE.USER_NOT_ENROLLED;
    }

    /**
     * get order
     * @returns {order}
     */
  }, {
    key: "history",
    get: function () {
      return this.data;
    }

    /**
     * has error
     * @return {boolean}
     */
  }, {
    key: "hasError",
    get: function () {
      return this.API_STATE === _constants.API_STATE.FAILED;
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "onSuccess",
    value:
    /**
     * handle success
     * @param {Object} data
     */
    function onSuccess(data) {
      this.data = data;
      this.API_STATE = _constants.API_STATE.SUCCESS;
    }

    /**
     * handle error
     * @param {Object} error
     * @param {Function} errorHandler
     */
  }, {
    key: "onError",
    value: function onError(error, errorHandler) {
      errorHandler(error);
      this.API_STATE = _constants.API_STATE.FAILED;
    }

    /**
     * Reset Store
     */
  }, {
    key: "resetStore",
    value: function resetStore() {
      this.API_STATE = _constants.API_STATE.INITIAL;
    }
  }]);
  return WalletHistoryStore;
}(), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "API_STATE", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return _constants.API_STATE.INITIAL;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isLoading", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLoading"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFetched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFetched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isUserNotEnrolled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUserNotEnrolled"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "history", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "history"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hasError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onSuccess", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSuccess"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "onError", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onError"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "resetStore", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetStore"), _class.prototype)), _class);
exports.default = WalletHistoryStore;